// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__o7iRB","label":"LabeledBox_label__3zX49"};